export const faqs = [
  {
    q: "Can you build fully custom software instead of a template?",
    a: "Yes — custom builds are our default. We start from your business requirement and workflow, then design the system around it. Templates and off-the-shelf tools are only used where they genuinely serve you better.",
  },
  {
    q: "Can you automate our existing manual processes?",
    a: "That's one of our core capabilities. We map the manual process first — data entry, follow-ups, report building, approvals — then automate it step by step, keeping humans in the loop where judgement is needed.",
  },
  {
    q: "Can you connect our existing tools?",
    a: "In most cases, yes. If your tools have APIs or export data, we can usually wire them together — and where a tool can't be connected, we'll tell you honestly and design around it.",
  },
  {
    q: "Can you build a custom CRM for our team?",
    a: "Yes. We build CRMs around your actual pipeline — leads, stages, roles, dashboards and reports — instead of forcing your team to adapt to a generic tool. It can also connect to your website and automation from day one.",
  },
  {
    q: "Can you build around our existing workflow?",
    a: "That's exactly how we work. Discovery starts with how your business actually runs today. The system is designed to fit your workflow — not the other way around.",
  },
  {
    q: "Do you provide ongoing support after launch?",
    a: "Yes. Build → Launch → Monitor → Improve is the model. After launch we can continue with maintenance, optimization, new features, integrations, automation and reporting — as a long-term technology partner.",
  },
  {
    q: "How is pricing structured?",
    a: "Project-based for defined builds, and monthly engagements for ongoing improvement, automation and SEO. Every engagement starts with a free discovery call where we scope the system and give you a clear, fixed proposal — no surprises later.",
  },
];
